import { SECTIONS } from "../Footprint/util";

// The Blog's sections used to be named as ?tab=<section> (its own page, before
// it moved into the Bulletin). On the Bulletin "tab" belongs to the board, so a
// link like /bulletin?tab=history would quietly open the board instead of the
// piece. Returns the Blog address such a link meant, or null when it is fine.
export function blogAddressFor(search, hash = "") {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  if (params.get("view") || !SECTIONS.some((s) => s.key === tab)) return null;
  return `/bulletin?${new URLSearchParams({ view: "blog", section: tab })}${hash}`;
}
